export default "__VITE_ASSET__BIOT3HAz__"